import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import LoadListSync01Actions, { LoadListSync01Types } from '../Stores/LoadListSync01/Actions';

const getAppStore = state => state.app;

export function* loadListSync01FetchLoadListSync01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(LoadListSync01Actions.loadListSync01FetchLoadListSync01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `loadList/indexProcess/LOAD_LIST_SYNC_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LoadListSync01Actions.loadListSync01FetchLoadListSync01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LoadListSync01Actions.loadListSync01FetchLoadListSync01Loading(false));
  }
}

export function* loadListSync01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/loadListDetail/update/${hdrId}`));
}

export function* loadListSync01SyncNow({ hdrIds }) {
  try {
    yield put(LoadListSync01Actions.loadListSync01SyncLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `loadList/syncProcess/LOAD_LIST_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(LoadListSync01Actions.loadListSync01SyncNowSuccess());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LoadListSync01Actions.loadListSync01SyncLoading(false));
  }
}

export const saga = [
  takeLatest(LoadListSync01Types.LOAD_LIST_SYNC01_GO_TO_DOCUMENT, loadListSync01GoToDocument),
  takeLatest(
    LoadListSync01Types.LOAD_LIST_SYNC01_FETCH_LOAD_LIST_SYNC01,
    loadListSync01FetchLoadListSync01
  ),
  takeLatest(LoadListSync01Types.LOAD_LIST_SYNC01_SYNC_NOW, loadListSync01SyncNow)
];
